import { __read } from "tslib";
import { useEffect, useState } from 'react';
export var smMediaQuery = "(max-width: 600px)";
export var mdMediaQuery = "(max-width: 768px)";
export var lgMediaQuery = "(max-width: 960px)";
export var xlMediaQuery = "(max-width: 1280px)";
export var xxlMediaQuery = "(max-width: 1440px)";
export var xxxlMediaQuery = "(max-width: 1920px)";
export var xxxxlMediaQuery = "(max-width: 2560px)";
export var useMediaQuery = function (query) {
    var _a = __read(useState(false), 2), queryMatch = _a[0], setQueryMatch = _a[1];
    useEffect(function () {
        var handleQueryListener = function () {
            if (window && window.matchMedia) {
                var mediaQuery_1 = window.matchMedia(query);
                var isMatch = mediaQuery_1.matches;
                setQueryMatch(isMatch);
                return mediaQuery_1;
            }
            return null;
        };
        var mediaQuery = handleQueryListener();
        if (mediaQuery) {
            mediaQuery.addEventListener('change', handleQueryListener);
        }
        return function () {
            if (mediaQuery) {
                mediaQuery.removeEventListener('change', handleQueryListener);
            }
        };
    }, [query]);
    return queryMatch;
};
